import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import UploadPlan from './pages/UploadPlan';
import ProjectForm from './pages/ProjectForm';
import Review from './pages/Review';
import Results from './pages/Results';
import Navbar from './components/Navbar';
import './App.css';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/upload" element={<UploadPlan />} />
          <Route path="/form" element={<ProjectForm />} />
          <Route path="/review" element={<Review />} />
          <Route path="/results" element={<Results />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;